// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"f65f1b4b","313":"74f0337b","352":"cfe8d582","453":"d456ce70","580":"cee898c3","764":"0ba21457"}[chunkId] + ".chunk.js";
};